import { useEffect } from "react";

const DEFAULT_TITLE = "EIGOO | Sovereign Provisions";
const DEFAULT_DESCRIPTION = "EIGOO Digital Provisions — the premier shipyard for industrial-grade Sovereign digital products, AI Blueprint Engine, and Ghost Crew automation for the elite operator class.";

export default function usePageMeta(title, description) {
  useEffect(() => {
    const fullTitle = title ? `${title} · EIGOO Provisions` : DEFAULT_TITLE;
    document.title = fullTitle;

    // Update meta description
    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement("meta");
      descTag.setAttribute("name", "description");
      document.head.appendChild(descTag);
    }
    descTag.setAttribute("content", description || DEFAULT_DESCRIPTION);

    // Update og:title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", fullTitle);

    // Update og:description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute("content", description || DEFAULT_DESCRIPTION);

    // Update twitter:title/description
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute("content", fullTitle);
    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute("content", description || DEFAULT_DESCRIPTION);

    return () => {
      // On unmount, restore defaults so other pages start clean
      document.title = DEFAULT_TITLE;
    };
  }, [title, description]);
}
